import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import NotificationsController from './NotificationsController';

import panel from '../../services';

export default angular.module('app.notifications', [uirouter, panel])
    .config(routing)
    .controller('NotificationsController', NotificationsController)
    .name;


// WEBPACK FOOTER //
// ./src/app/features/notifications/index.js